

































































































































































































































































































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  alertStore,
  appStore,
  dataStore,
  modalErrorStore,
  modalUserDetailStore,
  systemCodeStore,
  systemParameterStore
} from '@/store'
import { AlertMessage, defaultUser, ErrorMessage, userApi, User } from '@/api'
import { PAGE_LOADING_END } from '@/config/event'
import { UserMemoAndNote } from '@/components/organisms/UserMemoAndNote'
import CODE_KEY from '@/config/code_key'
import {
  AlertCodeWAR00001,
  defaultUserDetailStateInfo,
  UserDetailPageState,
  UserDetailStateInfo,
  UserDetailTabType,
  UserExternalCollaborationStatus
} from '@/types'
import dayjs from 'dayjs'
import { AlertFactory } from '@/factory'
import { UserDetailItem, defaultUserDetailItem } from '@/pages/user/_id.vue'
import {
  UserContentBasic,
  UserDetailUserInfo,
  UserContentUsageSituation,
  UserContentOtherContacts,
  UserContentFamily,
  UserContentNewArrivalNotice,
  UserContentOldName,
  UserContentMailHistory,
  UserContentLending,
  UserContentReserved,
  UserExternalCollaboration,
  defaultUserExternalCollaborationItem
} from '@/components/templates/user-detail'
import { SearchResultPagination } from '@/components/molecules/SearchResultPagination'
import { UserSearchTableItem } from '@/components/organisms/UserSearchTable'

@Component({
  components: {
    UserExternalCollaboration,
    SearchResultPagination,
    UserDetailUserInfo,
    UserMemoAndNote,
    ModalFooter,
    UserContentBasic,
    UserContentUsageSituation,
    UserContentOtherContacts,
    UserContentFamily,
    UserContentNewArrivalNotice,
    UserContentOldName,
    UserContentLending,
    UserContentReserved,
    UserContentMailHistory
  }
})
export default class ModalUserDetail extends ModalComponentBaseVue {
  user: User = defaultUser()

  item: UserDetailItem = defaultUserDetailItem()

  state: UserDetailStateInfo = defaultUserDetailStateInfo()

  activeTab: UserDetailTabType = UserDetailTabType.Basic

  height: number = 0

  // 利用者照会ページで利用者の照会ダイアログを表示できる為、ダイアログ側で更新処理をしたか判定する値を用意
  // 値を元にページ側を更新するか判定する
  isUpdated: boolean = false

  // ページ側と違い編集画面は使用しないのでそれを考慮した条件式は削除とする
  get displayFamilyTab(): boolean {
    return systemParameterStore.isManagementFamily && !this.state.isGroup()
  }

  // ページ側と違い編集画面は使用しないのでそれを考慮した条件式は削除とする
  get displayMailHistoryTab(): boolean {
    return this.isDisplayMailSendHistory
  }

  get displayWorkType(): boolean {
    return dataStore.displayUserPageWorkType
  }

  get isOpen(): boolean {
    return modalUserDetailStore.isOpen
  }

  get isPagination(): boolean {
    return this.currentPage !== 0 && this.searchResult.items.length > 0
  }

  get searchResult(): UserSearchTableItem {
    return modalUserDetailStore.searchResult
  }

  get currentPage(): number {
    return (
      this.searchResult
        .sortedItems()
        .findIndex(item => item.id === this.user.base.id) + 1
    )
  }

  get titleLink(): boolean {
    return modalUserDetailStore.isTitleLink
  }

  get tabType(): any {
    return UserDetailTabType
  }

  get isDisplayMailSendHistory(): boolean {
    return systemParameterStore.isDisplayMailSendHistory
  }

  get initialActiveTab(): UserDetailTabType {
    return modalUserDetailStore.initialActiveTab
  }

  get tabStyles(): object {
    if (appStore._fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': appStore._fontSizeNormal + 'px'
    }
  }

  get lendingBadgeColor(): string {
    return this.user.lendCollections.length > 0 ? 'green' : 'grey'
  }

  get reservedBadgeColor(): string {
    if (this.user.reserveCollections.length === 0) {
      return 'grey'
    }

    let badgeColor: string = ''

    for (const collection of this.user.reserveCollections) {
      switch (collection.reserveStatusMessage) {
        case '受取待':
          if (
            collection.reserveExpiration !== '' &&
            collection.reserveExpiration < dayjs().format('YYYYMMDD')
          ) {
            return 'red'
          } else {
            badgeColor = 'yellow accent-4'
          }
          break
        case '準備中':
          if (badgeColor !== 'yellow accent-4') {
            badgeColor = '#99D9EA'
          }
          break
        case '回送中':
          if (badgeColor !== 'yellow accent-4' && badgeColor !== '#99D9EA') {
            badgeColor = 'orange'
          }
          break
        case '返却待':
          if (badgeColor === '') {
            badgeColor = 'green'
          }
      }
    }

    return badgeColor !== '' ? badgeColor : 'green'
  }

  get displayOtherContactTab(): boolean {
    return dataStore.displayUserPageOtherContactTab
  }

  get displayNewArrivalNoticeTab(): boolean {
    return dataStore.displayUserPageNewArrivalNoticeTab
  }

  get displayOldNameTab(): boolean {
    return dataStore.displayUserPageOldNameTab
  }

  get displayExternalCollaborationTab(): boolean {
    return dataStore.displayUserPageExternalCollaborationTab
  }

  @Watch('isOpen')
  onShowChanged(val: boolean) {
    if (val) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.LIBRARY_BRANCH.KEY,
        CODE_KEY.REMIND_EXCLUDE.KEY,
        CODE_KEY.CLASSIFICATION.KEY // 貸出状況票レシート印刷で使用
      ])
      systemParameterStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.USER_OPAC_PASSWORD_SETTING.KEY, // opacパスワード非表示処理で使用
        CODE_KEY.FAMILY_MANAGEMENT_BASIC_NUMBER_SETTING.KEY,
        CODE_KEY.MAIL_HISTORY_SETTING.KEY,
        CODE_KEY.LEND_OUT_TAB_DISPLAY_ITEM_SETTING.KEY
      ])
      this.fetchUser(modalUserDetailStore.userId).then(() => {
        // 取得処理を完了させてから初期タブを表示しないと、タブにもよるが一覧データを表示できなく時があるためタイミングを意図的に遅らせる
        this.activeTab = this.initialActiveTab
      })
      this.alertOldId()
      window.addEventListener('resize', this.calculateTableHeight)

      this.$nextTick(this.calculateTableHeight)
      return
    }

    window.removeEventListener('resize', this.calculateTableHeight)
    this.user = defaultUser()
    this.item = defaultUserDetailItem()
    this.state = defaultUserDetailStateInfo()
    this.activeTab = UserDetailTabType.Basic
    this.height = 0
    this.isUpdated = false
  }

  @Watch('activeTab')
  onChangeTab(): void {
    this.calculateTableHeight()
  }

  // ページネーションの表示タイミングが少々遅く、縦幅処理がおかしくなるので変更を検知する
  // 必要がなければ削除したいs
  @Watch('isPagination')
  onChangeIsPagination(): void {
    this.$nextTick(this.calculateTableHeight)
  }

  onClickOk() {
    modalUserDetailStore.ok()
  }

  onClickCancel(): void {
    modalUserDetailStore.cancel(this.isUpdated)
  }

  calculateTableHeight(): void {
    this.height = 0

    this.$nextTick(() => {
      this.height = this.calculateTableHeightBase()
      if (
        (this.activeTab === this.tabType.NewArrivalNotice &&
          this.state.isCreateOrUpdate()) ||
        this.activeTab === this.tabType.OldName
      ) {
        this.height /= 2
      } else if (this.activeTab === this.tabType.NewArrivalNotice) {
        this.height /= 3
      }
    })
  }

  setInitialActiveTab(): void {
    const initializeActiveTab = () => (this.activeTab = UserDetailTabType.Basic)

    switch (this.activeTab) {
      case UserDetailTabType.Family:
        if (!this.displayFamilyTab) {
          initializeActiveTab()
        }
        break
      case UserDetailTabType.MailHistory:
        if (!this.displayMailHistoryTab) {
          initializeActiveTab()
        }
        break
    }
  }

  changeTab(tabType: UserDetailTabType): void {
    this.activeTab = tabType
  }

  alertOldId(): void {
    if (
      modalUserDetailStore.displayOldIdAlert &&
      modalUserDetailStore.searchedConditions.id.input !== '' &&
      modalUserDetailStore.searchedConditions.id.input ===
        this.user.base.cardLost.uno
    ) {
      alertStore.setItem(
        AlertFactory.create(
          AlertCodeWAR00001,
          `旧カード番号：${this.user.base.cardLost.uno}`,
          '再発行済み'
        )
      )
      this.$modalAlert.open({
        modalType: 'INFO'
      })
    }
  }

  async fetchUser(id: string) {
    try {
      this.user = await userApi.getUser({
        id
      })

      if (this.user.group.name !== '') {
        this.state.state = UserDetailPageState.GroupShow
      } else {
        this.state.state = UserDetailPageState.UserShow
      }

      this.item = {
        info: {
          userId: {
            input: this.user.base.id,
            errorMessage: ''
          },
          userType: {
            input: this.user.base.userType.code,
            display: this.user.base.userType.shortName,
            errorMessage: ''
          },
          workType: this.user.personal.workType,
          name: {
            input: this.state.isGroup()
              ? this.user.group.name
              : this.user.personal.name,
            errorMessage: ''
          },
          expirationDate: {
            input: this.user.base.expirationDate,
            errorMessage: ''
          },
          nameKana: {
            input: this.state.isGroup()
              ? this.user.group.nameKana
              : this.user.personal.nameKana,
            errorMessage: ''
          },
          userStatus: {
            input: this.user.base.status,
            errorMessage: ''
          },
          studentGrade: {
            input: this.user.personal.studentGrade.code,
            display: this.user.personal.studentGrade.shortName,
            errorMessage: ''
          },
          studentClass: {
            input: this.user.personal.studentClass.code,
            display: this.user.personal.studentClass.shortName,
            errorMessage: ''
          },
          studentNumber: {
            input: this.user.personal.studentNumber,
            errorMessage: ''
          }
        },
        memoAndNote: {
          id: this.user.base.id,
          memos: this.user.memos,
          notes: this.user.notes
        },
        basic: {
          id: this.user.base.id,
          registeredDate: {
            input: this.user.base.registeredDate,
            errorMessage: ''
          },
          branchCode: {
            input: this.user.base.branchCode.code,
            display: this.user.base.branchCode.shortName,
            errorMessage: ''
          },
          myBranchCode: {
            input: this.user.base.myBranchCode.code,
            display: this.user.base.myBranchCode.shortName,
            errorMessage: ''
          },
          reserveReceivePlaceCode: {
            input: this.user.base.reserveReceivePlaceCode.code,
            display: this.user.base.reserveReceivePlaceCode.shortName,
            errorMessage: ''
          },
          ppid: this.user.base.ppid,
          felicaId: this.user.base.felicaId,
          birthdayJapaneseSymbol: {
            input: this.user.personal.birthdayJapaneseSymbol,
            errorMessage: ''
          },
          birthday: {
            input: this.user.personal.birthday,
            errorMessage: ''
          },
          gender: {
            input: this.user.personal.gender,
            errorMessage: ''
          },
          groupType: {
            input: this.user.group.groupType.code,
            display: this.user.group.groupType.shortName,
            errorMessage: ''
          },
          reserveNotice: {
            input: this.user.base.reserveNotice.code,
            display: this.user.base.reserveNotice.shortName,
            errorMessage: ''
          },
          myPageEnabled: {
            input: this.user.opac.myPageEnabled,
            errorMessage: ''
          },
          reserveEnabled: {
            input: this.user.opac.reserveEnabled,
            errorMessage: ''
          },
          password: {
            input: this.user.opac.password,
            errorMessage: ''
          },
          registeredPassword: this.user.opac.password,
          passwordRegisteredDate: this.user.opac.registeredDate,
          disability: {
            input: this.user.personal.disability,
            errorMessage: ''
          },
          readingSupportEnabled: {
            input: this.user.base.readingSupportEnabled,
            errorMessage: ''
          },
          numberOfGroupMembers: {
            input: String(this.user.group.groupMember.numberOfGroupMembers),
            errorMessage: ''
          },
          numberOfGroupChildren: {
            input: String(this.user.group.groupMember.numberOfGroupChildren),
            errorMessage: ''
          },
          phones: (this.state.isGroup()
            ? this.user.group.phones
            : this.user.personal.phones
          ).map(phone => ({
            id: phone.id,
            contact: phone.contact,
            number: {
              input: phone.number,
              errorMessage: ''
            },
            type: {
              input: phone.type.code,
              display: phone.type.shortName,
              errorMessage: ''
            }
          })),
          addressCode: {
            input: this.state.isGroup()
              ? this.user.group.userAddress.addressCode
              : this.user.personal.userAddress.addressCode,
            errorMessage: ''
          },
          zipCode: {
            input: this.state.isGroup()
              ? this.user.group.userAddress.zipCode
              : this.user.personal.userAddress.zipCode,
            errorMessage: ''
          },
          areaCode: {
            input: this.state.isGroup()
              ? this.user.group.userAddress.areaCode
              : this.user.personal.userAddress.areaCode,
            errorMessage: ''
          },
          address: {
            input: this.state.isGroup()
              ? this.user.group.userAddress.address
              : this.user.personal.userAddress.address,
            errorMessage: ''
          },
          mailAddresses: (this.state.isGroup()
            ? this.user.group.mailAddresses
            : this.user.personal.mailAddresses
          ).map(mailAddress => ({
            id: mailAddress.id,
            address: {
              input: mailAddress.address,
              errorMessage: ''
            },
            reserve: mailAddress.reserve,
            newArrival: mailAddress.newArrival,
            remind: mailAddress.remind,
            notice: mailAddress.notice,
            event: mailAddress.event,
            type: {
              input: mailAddress.type.code,
              display: mailAddress.type.shortName,
              errorMessage: ''
            }
          }))
        },
        usageSituation: {
          lendTotalCount: this.user.nowStatus.lendTotalCount,
          lendTotalLimit: this.user.nowStatus.lendTotalLimit,
          insideReadingCount: this.user.nowStatus.insideReadingCount,
          reserveCount: this.user.nowStatus.reserveCount,
          lostCount: this.user.nowStatus.lostCount,
          suspendReason: {
            input: this.user.nowStatus.suspendReason.code,
            display: this.user.nowStatus.suspendReason.shortName,
            errorMessage: ''
          },
          suspendLimit: {
            input: this.user.nowStatus.suspendLimit,
            errorMessage: ''
          },
          updatedDate: this.user.nowStatus.updatedDate,
          lendDate: this.user.nowStatus.lendDate,
          remindDate: this.user.nowStatus.remindDate,
          remindExclude: {
            input: this.user.nowStatus.remindExclude,
            errorMessage: ''
          },
          remindTotal: this.user.nowStatus.remindTotal,
          remindWay: this.user.nowStatus.remindWay,
          overdueCount: this.user.nowStatus.overdueCount,
          lendCountList: this.user.nowStatus.lendCountList,
          lendLatestCount: this.user.nowStatus.lendLatestCount,
          lendLatestLimit: this.user.nowStatus.lendLatestLimit,
          lendCountHistory: this.user.lendCountHistory,
          studentLendCountHistory: this.user.studentLendCountHistory,
          remindCountHistory: this.user.remindCountHistory,
          reserveCountHistory: this.user.reserveCountHistory,
          requestReserveCountHistory: this.user.requestReserveCountHistory,
          cardLostUno: this.user.base.cardLost.uno,
          cardLostCount: {
            input: String(this.user.base.cardLost.count),
            errorMessage: ''
          },
          cardLostReissueDate: {
            input: String(this.user.base.cardLost.reissue),
            errorMessage: ''
          },
          cardLostDate: {
            input: this.user.base.cardLost.lost,
            errorMessage: ''
          }
        },
        otherContacts: {
          guardian: {
            input: this.state.isGroup()
              ? this.user.group.guardian
              : this.user.personal.guardian,
            errorMessage: ''
          },
          guardianKana: {
            input: this.state.isGroup()
              ? this.user.group.guardianKana
              : this.user.personal.guardianKana,
            errorMessage: ''
          },
          workType: {
            input: this.user.personal.workType.code,
            display: this.user.personal.workType.shortName,
            errorMessage: ''
          },
          otherContacts: (this.state.isGroup()
            ? this.user.group.otherContacts
            : this.user.personal.otherContacts
          )
            .map(otherContact => ({
              id: otherContact.id,
              type: {
                input: otherContact.type.code,
                display: otherContact.type.shortName,
                errorMessage: ''
              },
              name: {
                input: otherContact.name,
                errorMessage: ''
              }
            }))
            .reverse()
        },
        family: {
          id: this.user.base.id,
          userFamilyId: this.user.personal.userFamilyId,
          familyUsers: this.user.familyUsers
        },
        newArrivalNotice: {
          genres: this.user.newArrivalNotice.genres
            .map(genre => ({
              id: genre.id,
              genre: {
                input: genre.genre.code,
                display: genre.genre.shortName,
                errorMessage: ''
              },
              opt1: genre.opt1
            }))
            .reverse(),
          keywords: this.user.newArrivalNotice.keywords
            .map(keyword => ({
              id: keyword.id,
              keyword: {
                input: keyword.keyword,
                errorMessage: ''
              }
            }))
            .reverse(),
          magazines: this.user.newArrivalNotice.magazines
            .map(magazine => ({
              id: magazine.id,
              displayTitle: magazine.displayTitle
            }))
            .reverse()
        },
        oldName: {
          oldNames: (this.state.isGroup()
            ? this.user.group.oldNames
            : this.user.personal.oldNames
          )
            .map(oldName => ({
              id: oldName.id,
              name: {
                input: oldName.name,
                errorMessage: ''
              },
              nameKana: {
                input: oldName.nameKana,
                errorMessage: ''
              }
            }))
            .reverse(),
          oldAddresses: (this.state.isGroup()
            ? this.user.group.oldAddresses
            : this.user.personal.oldAddresses
          )
            .map(oldAddress => ({
              id: oldAddress.id,
              addressCode: {
                input: oldAddress.addressCode,
                errorMessage: ''
              },
              address: {
                input: oldAddress.address,
                errorMessage: ''
              }
            }))
            .reverse()
        },
        lending: {
          id: this.user.base.id,
          name: this.state.isGroup()
            ? this.user.group.name
            : this.user.personal.name,
          revision: this.user.base.revision,
          userType: this.user.base.userType,
          lendCollections: this.user.lendCollections,
          remindHistories: this.user.remindHistories
        },
        reserved: {
          id: this.user.base.id,
          reserveCollections: this.user.reserveCollections,
          reserveCancelCollections: this.user.reserveCancelCollections
        },
        mailHistory: {
          mailHistories: this.user.mailHistories
        },
        externalCollaboration:
          this.user.externalCollaboration.status ===
          UserExternalCollaborationStatus.Issued
            ? {
                ...defaultUserExternalCollaborationItem(),
                userId: this.$route.params.id,
                externalId: {
                  ...defaultUserExternalCollaborationItem().externalId,
                  input: this.user.externalCollaboration.externalId
                },
                externalPassword: this.user.externalCollaboration
                  .externalPassword,
                registrationDate: {
                  ...defaultUserExternalCollaborationItem().registrationDate,
                  input: this.user.externalCollaboration.registrationDate
                },
                registrationBranchCode: {
                  ...defaultUserExternalCollaborationItem()
                    .registrationBranchCode,
                  input: this.user.externalCollaboration.registrationBranchCode
                    .code,
                  display: this.user.externalCollaboration
                    .registrationBranchCode.shortName
                },
                status: this.user.externalCollaboration.status
              }
            : {
                ...defaultUserExternalCollaborationItem(),
                userId: this.$route.params.id,
                status: this.user.externalCollaboration.status
              }
      }

      this.setInitialActiveTab()

      this.calculateTableHeight()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-user-detail')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  prev(): void {
    this.fetchUser(this.searchResult.sortedItems()[this.currentPage - 2].id)
  }

  next(): void {
    this.fetchUser(this.searchResult.sortedItems()[this.currentPage].id)
  }
}
